exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ptr--ptr{box-shadow:none!important;font-weight:400!important;margin-bottom:-60px;margin-top:60px}.ptr--ptr.ptr--pull,.ptr--ptr.ptr--refresh,.ptr--ptr.ptr--release{border-bottom:1px solid #0072c9}.ptr--ptr .ptr--box .ptr--content .ptr--icon,.ptr--ptr .ptr--box .ptr--content .ptr--text{margin-top:-5px!important;color:#0072c9!important}.ptr--ptr .ptr--box .ptr--content .ptr--text{font-size:12px!important}.ptr--ptr .ptr--box .ptr--content .ptr--icon{font-size:16px!important;display:block;margin-bottom:5px}.inception-pull-to-refresh .ptr--ptr{margin-bottom:-188px;margin-top:188px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/common/directives/pullToRefresh.scss
// module id = 614
// module chunks = 0